import LightIcon from "../../../assets/images/LightIcon.png";
import DarkIcon from "../../../assets/images/DarkIcon.png";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDarkmodeContext } from "react-use-dark-mode";

const ThemeOption = (props) => {
  const { t } = useTranslation();
  const { mode, toggleMode } = useDarkmodeContext();

  return (
    <div className="BalanceText">
      {mode === "light" ? <p> {t("Light_Mode")} </p> : <p> {t("Dark_Mode")}</p>}
      <div className="theme-btns">
        <button onClick={toggleMode}>
          {mode === "light" ? (
            <img src={LightIcon} alt="Light Mode" />
          ) : (
            <img src={DarkIcon} alt="Dark Mode" />
          )}
        </button>
      </div>
    </div>
  );
};

function areEqual(prevProps, nextProps) {
  return prevProps.toggleStatus === nextProps.toggleStatus;
}

export default React.memo(ThemeOption, areEqual);
